import React from 'react';
import {SVGProps} from '~/src/components/svg/SVGProps';

const NavCockpit = ({primaryClassName, secondaryClassName, tertiaryClassName}: SVGProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <rect className={primaryClassName} x="6" y="7.82" width="20" height="1.82" />
        <rect className={secondaryClassName} x="10.55" y="22.36" width="15.45" height="1.82" />
        <rect className={tertiaryClassName} x="6" y="22.36" width="4.55" height="1.82" />
        <path
            className={primaryClassName}
            d="M16.78,15.09a3.62,3.62,0,0,0-7,0H6v1.82H9.77a3.62,3.62,0,0,0,7,0H26V15.09ZM15.09,16a1.88,1.88,0,0,1-.25.91,1.83,1.83,0,0,1-1.57.91,1.82,1.82,0,0,1,0-3.64,1.83,1.83,0,0,1,1.57.91A1.88,1.88,0,0,1,15.09,16Z"
        />
    </svg>
);

export default NavCockpit;
